<template>
    <!-- Start Main Content -->
    <div v-if="!invoice" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Service Subscription List</h2>
         
         
        <div class="grid grid-cols-12 gap-4 mb-6 mt-2 items-end">
          <div class="col-span-4">
              <label for="from_date" class="form-label">From Date</label>
              <input type="date" v-model="fromDate" class="form-input" id="from_date">
          </div>
          <div class="col-span-4">
              <label for="to_date" class="form-label">To Date</label>
              <input type="date" v-model="toDate" class="form-input" id="to_date">
          </div>
          <div class="col-span-4 flex items-end">
              <!-- Empty label for spacing alignment -->
              <!-- <label class="form-label invisible">Filter</label> -->
              <button @click="filterByDate" class="btn b-solid btn-primary-solid">Filter</button>
          </div>
      </div>
      <div class="grid grid-cols-12 gap-4 mb-6 items-end">
        
    </div>
  </div>
      
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                  <div class="col-span-4 flex items-end" v-if="isResetBtn">
                      <button  @click="showAll" class="btn b-solid btn-primary-solid resetbtn"> Show All</button>
                  </div>

                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Service Name</th>
                                    <th class="bg-[#B2E8D9]">Staff Name</th>
                                    <th class="bg-[#B2E8D9]">Member Name</th>
                                    
                                    <th class="bg-[#B2E8D9]">From Date</th>
                                    <th class="bg-[#B2E8D9]">To Date</th>
                                    <th class="bg-[#B2E8D9]">Amount</th>
                                    <th class="bg-[#B2E8D9]">Note</th>
                                    <th class="px-3.5 py-4">Action</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <!-- <tr v-for="(item ,index)  in filteredList" :key="item.id">
                                    <td>{{item.service_name}}</td>
                                    <td>{{item.member_name}}</td>
                                    <td>{{item.from_date}}</td>
                                    <td>{{item.to_date}}</td>
                                    <td>{{item.total_amt}}</td>
                                    <td>{{item.note}}</td> -->

                                  
                                    <!-- <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">
                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>

                                        </div>
                                    </td> -->
                                <!-- </tr>  -->
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->


       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <!-- End Delete Modal -->
    <!-- <div class="form-container" v-if="invoice">
        <div class="form-header">
          <img src="logo.png" alt="Logo">
          <h2 class="form-title">Service Subscription</h2>
        </div>
      
        <div class="section">
          <div class="section-title">Contact Details</div>
          <div class="row">
            <div class="col-50">
              <div class="form-group">
                <label>Full Name:</label>
                <p>{{invoice.firstname}} {{invoice.lastname}}</p>
              </div>
              <div class="form-group">
                <label>Date of Birth:</label>
                <p>{{invoice.dob}}</p>
              </div>
              <div class="form-group">
                <label>Gender:</label>
                <p>{{invoice.gender}}</p>
              </div>
              <div class="form-group">
                <label>Contact Number:</label>
                <p>{{invoice.phonenumber}}</p>
              </div>
            </div>
            <div class="col-50">
              <div class="form-group">
                <label>Membership ID:</label>
                <p></p>
              </div>
              <div class="form-group">
                <label>Email:</label>
                <p>{{invoice.email}}</p>
              </div>
              <div class="form-group">
                <label>Address:</label>
                <p>{{invoice.address}}</p>
              </div>
              <div class="form-group">
                <label>Adhar Card No.:</label>
                <p>{{invoice.aadharno}}</p>
              </div>
            </div>
          </div>
        </div>
      
        
      
      
        <div class="section">
          <div class="section-title">Service Subscription Details</div>
          <div class="form-group">
            <label>Service Name:</label>
            <p>{{invoice.name}}</p>
          </div>
          <div class="form-group">
            <label>Staff Name:</label>
            <p>{{invoice.firstname}}</p>
          </div>
          <div class="form-group">
            <label>From Date:</label>
            <p>{{invoice.from_date}}</p>
          </div>
          <div class="form-group">
            <label>To Date:</label>
            <p>{{invoice.to_date}}</p>
          </div>
          <div class="form-group">
            <label>Amount:</label>
            <p>{{invoice.total_amt}}</p>
          </div>
        </div>
      
        
        
        <div class="footer">
          <p>&copy; FITRIUM GYM. All rights reserved.</p>
        </div>
      </div> -->
    

</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted() {
  const staffid = localStorage.getItem('selectedStaffId');

  if (staffid) {
    this.fetchStaffData(staffid);
    localStorage.removeItem('selectedStaffId');
  } else {
    this.getBasics();
  }
},

data() {
  const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     invoice:null,
     servicesubscriptionlist:[],
     filteredList: [],
     fromDate:today,
     toDate:today,
     isResetBtn:false
    

 }
 }, 
//  created() {
//     // Retrieve the staffid from localStorage
//     const staffid = localStorage.getItem('selectedStaffId');

//     if (staffid) {
//       this.fetchStaffData(staffid); // Fetch data if staffid exists
//     }
//   },
methods:{
  fetchStaffData(staffid) {
      axios.post(`getStaffSubscription/${staffid}`)
        .then(response => {
          this.servicesubscriptionlist = response.data.subscriptions; 
          this.filteredList = this.servicesubscriptionlist;
          this.initDataTable(this.filteredList);
        })
        .catch(error => {
          console.error('Error fetching staff data:', error);
        });
    },
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
        
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('servicesubscriptionlist').then(function (response) {
                  localStorage.removeItem('selectedStaffId');
                  self.servicesubscriptionlist=response.data.servicessubscription;
                  self.filteredList = self.servicesubscriptionlist;
                  self.initDataTable(self.filteredList);
                }).then(()=>{ 
                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false,
                    //         "dom": 'Bfrtip',
                    //         "buttons": [
                    //         {
                    //             extend: 'excelHtml5', // Specify the button type
                    //             text: 'Export to Excel', // Button text
                    //             title: 'Services Subscription' // Title for the Excel file
                    //         }
                    //         ] 

                    //     });

                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false

                    //     });
              
                    });
  }, 

  initDataTable(data) {
    if ($.fn.dataTable.isDataTable('.datatable')) {
        $('.datatable').DataTable().clear().destroy();
    }

    let self = this;
    self.datatable = $('.datatable').DataTable({
        data: data,
        columns: [
            {
                data: 'service_name',
                render: function(data, type, row) {
                    return `<span class="clickable-cell" data-type="service_name" data-value="${data}" data-id="${row.id}">${data}</span>`;
                }
            },
            {
                data: 'staff_name',
                render: function(data, type, row) {
                    return `<span class="clickable-cell" data-type="staff_name" data-value="${data}" data-id="${row.id}">${data}</span>`;
                }
            },
            {
                data: 'member_details',
                render: function(data, type, row) {
                    return `<span class="clickable-cell" data-type="member_details" data-value="${data}" data-id="${row.id}">${data}</span>`;
                }
            },
            { data: 'from_date' },
            { data: 'to_date' },
            { data: 'total_amt' },
            { data: 'note' },
             {
            // Add a column for the "Print Invoice" button
            data: 'id', // You can use any unique identifier or `memberid`
            render: function(data, type, row) {
                return `
                    <button class="btn-icon btn-primary-icon-light size-7 print-invoice" 
                        data-memberid="${row.member_id}">
                        <i class="ri-printer-line text-primary text-[13px]"></i>
                    </button>`;
            },
        },
            
        ],
        paging: true,
        ordering: true,
        autoWidth: false,
        order: [[0, 'desc']],
        dom: 'Bfrtip', 
        buttons: [
                 {
                  extend: 'excelHtml5',            
                  title: 'Excel',              
                  },
                 ],
    });

    // Add click event listener for filtering
    $('.datatable').on('click', '.clickable-cell', function() {
        const field = $(this).data('type');
        const value = $(this).data('value');
        self.filter_user(field, value);
    });
    
    $('.datatable').on('click', '.print-invoice', function() {
    const memberid = $(this).data('memberid');
    self.navigateToPrintPage(memberid); 
    });
},
filter_user(field, value) {
    // Filter based on servicesubscriptionlist instead of memberlist
    this.filteredList = this.servicesubscriptionlist.filter(item => item[field] === value);
    console.log(this.filteredList);
    this.initDataTable(this.filteredList); // Update DataTable with filtered data
},
navigateToPrintPage(memberId) {
    const url = `${window.location.origin}/#/servicesubinvoice/print?id=${memberId}`;
    const newWindow = window.open(url, '_blank');
    
    // Ensure the new tab is opened before triggering print
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("Popup blocked. Please allow popups for this site.");
    }
  },
showAll() {
          this.isResetBtn=false;
            // Reset the filteredList to show all data
            this.filteredList = this.servicesubscriptionlist;
            this.initDataTable(this.filteredList); // Update DataTable with full list
        },
        clearFilter() {
            // Similar to showAll, it resets the table to original data
            this.showAll();
        },
            delete_category() {
                var self = this; 
                axios.post('deletesubscription', {deleteId:this.deleteId})
                    .then(response => {
                        self.subscriptionlist=response.data.subscription;
                        self.employees=response.data.userDetails; 
                         self.closeModal();
                         self.getBasics();
                        //  location.reload();
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
        filterByDate() {
            if (this.fromDate && this.toDate) {
                this.isResetBtn=true;
                this.filteredList = this.servicesubscriptionlist.filter(item => {
                    return item.to_date >= this.fromDate && item.to_date <= this.toDate;
                });
            } else {
                this.isResetBtn=false;
                this.filteredList = this.servicesubscriptionlist;
            }
            this.initDataTable(this.filteredList);
        },
}
}
</script>
<style scoped>
  * {
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }

  body {
    background-color: #f3f3f3;
    padding: 20px;
  }

  .form-container {
    width: 800px;
    margin: auto;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 20px;
  }

  .form-header {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-header img {
    width: 100px;
    margin-bottom: 10px;
  }

  .form-title {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
  }

  .section {
    margin-bottom: 15px;
  }

  .section-title {
    font-weight: bold;
    font-size: 18px;
    background-color: #000;
    color: #fff;
    padding: 5px;
    margin-bottom: 10px;
  }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .form-group label {
    flex: 0 0 200px;
    font-weight: bold;
  }

  .form-group input {
    flex: 1;
    padding: 5px;
    border: 1px solid #ddd;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-50 {
    width: 50%;
    padding: 0 10px;
  }

  .col-100 {
    width: 100%;
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
  </style>
